export default{
    cervicalLengthMeasurement:'Cervical Length Measurement',
    indication:'indication',
    medicalAbbreviationTest:'medical Abbreviation Test',
    gestationalMedicalAbbreviationTest:'gestational Medical Abbreviation Test',
    weeks:'weeks',
    day:'day',
    date:'date',
    examinationMethod:'examination Method',
    examinationView:'examination View',
    cardiacActivity:'cardiac Activity',
    cervixDescription:'cervix Description',
    cervicalLengthMeasured:'cervical Length Measured',
    placentaLocation:'placenta Location',
    impressionLocation:'impression Location',
    finalDescription:'final Description',
}